import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider, { Settings } from "react-slick";
import { TvModel, TvAction } from "src/store";
import { TvChannelCard } from "./tv.channel.card";
import { TvChannelCardMobile } from "./tv.channel.card.mobile";
import { TvChannelCardMobileShimmer } from "./tv.channel.card.mobile.shimmer";
import { TvChannelCardShimmer } from "./tv.channel.card.shimmer";

export const TvChannelsList: React.FC = () => {

    //#region Dependencies

    const dispatch = useDispatch();
    const conductor: TvModel = useSelector((state: any) => state.TvState);

    //#endregion

    //#region properties

    const reveresed = [...conductor.channels].reverse();

    const initialSlide = reveresed.findIndex((x) => x.id === conductor.currentChannel?.id);

    const carouselSetting: Settings = {
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 2,
                }
            }
        ],
        infinite: reveresed.length > 4,
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: true,
        centerMode: true,
        centerPadding: "0px",
        initialSlide
    };

    //#endregion

    //#region methods

    const fetchData = useCallback(() => {

        dispatch(TvAction.requestChannels());

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, conductor]);

    //#endregion

    //#region effects

    useEffect(() => {
        if (!conductor.channels.length) fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //#endregion

    //#region helpers

    const renderCarouselItems = () => {
        if (conductor.channels.length && initialSlide > -1) {
            return (
                reveresed.map((channel) => (
                    <TvChannelCard {...channel} key={channel.id} />
                ))
            );
        }

        if (!conductor.channels.length && !conductor.channelsLoading) return;

        return (
            [...new Array(5)].map((channel, index) => (
                <TvChannelCardShimmer key={index} />
            ))
        );
    };

    const renderMobileItems = () => {

        if (conductor.showConductor) return;

        if (conductor.channels.length && !conductor.channelsLoading) {
            return (conductor.channels.map((channel) => (
                <TvChannelCardMobile key={channel.id} {...channel} />
            )));
        }

        if (!conductor.channels.length && !conductor.channelsLoading) return;

        return (
            [...new Array(5)].map((channel, index) => (
                <TvChannelCardMobileShimmer key={index} />
            ))
        );
    };

    //#endregion



    return (
        <div className="component-live-tv-conductor">
            <div className="container">
                <div className="row">
                    <div className="col-12 px-3">
                        <div className="d-block d-lg-none">
                            {renderMobileItems()}
                        </div>
                        <div className="tv-carousel slick-carousel d-none d-lg-block mb-5 mt-3">
                            <Slider {...carouselSetting} key={initialSlide > -1 ? "list" : "shimmer"}>
                                {renderCarouselItems()}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
